import React from 'react';
import styles from './ActorCard.module.css';

/**
 * @component ActorCardImage
 * @description 배우 카드 이미지 영역 (독립 컴포넌트)
 *
 * src가 없을 때는 이름 이니셜 플레이스홀더를 렌더링한다.
 * 실제 이미지 자산으로 교체할 때 src props 값만 변경하면 된다.
 *
 * @param {string|null} props.src   - 이미지 경로 (null이면 플레이스홀더)
 * @param {string}      props.alt   - 이미지 대체 텍스트 (이름)
 * @param {string}      props.name  - 플레이스홀더에 표시할 이름 (이니셜 추출용)
 */
function ActorCardImage({ src, alt, name }) {
  const initial = name ? name.charAt(0) : '?';

  return (
    <div className={styles.imageWrapper}>
      {src ? (
        <img className={styles.image} src={src} alt={alt} loading="lazy" decoding="async" width={220} height={293} />
      ) : (
        <div className={styles.imagePlaceholder}>
          <span className={styles.initial}>{initial}</span>
        </div>
      )}
    </div>
  );
}

export default ActorCardImage;
